module.exports = __webpack_public_path__ + "static/media/silesia-towers.cdb04c9c.mp4";